<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="main-container">
    <el-col
      :sm="8"
      :lg="7"
      :xl="6"
      class="goals-main-list">
      <el-row>
        <el-col class="main-header">
          <h1>Objetivos</h1>
          <el-button
            v-if="!hideActions"
            circle
            @click="onShowGoalsPanel">
            <i class="icon-plus"/>
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <goals-list
            :goals-items="listItems"
            :goals="listItemsGoals"
            :hide-actions="hideActions"
            :focus-first="focusFirst"
            goals-items-type="branch"
            @clickOnItem="clickOnItem"
            @onEdit="onEdit"/> <!-- TODO: change to respective type -->
        </el-col>
      </el-row>
    </el-col>
    <el-col
      :sm="16"
      :lg="17"
      :xl="18"
      class="container-section-main">
      <goals-chart-preview
        :goals="currentGoals"
        :global-goals="globalGoals"
        :item="currentGoalItem"
        :met-goals="metGoals"
        :show-global="showGlobal"
        :hide-parent="hideParent"
        item-type="branch"
        @show-global="toggleGoals"/> <!-- TODO: change to respective type -->
    </el-col>
    <goals-create-panel
      v-if="showGoalsPanel"
      :edit="edit"
      :items="listItems"
      :item="currentGoalItem"
      :goals="currentGoals"
      item-type="branch"
      @closeModal="onCloseGoalsPanel"
      @onCreate="reloadList"/> <!-- TODO: change to respective type -->
  </el-row>
</template>

<script>
/**
*
* GoalsDealerView Component
*
* @author Eduardo Espinosa
* @copyright 2018, Marciano Studio S.C.
*/
import GoalsList from '@/modules/goals/goals-dealer-list.vue'
import GoalsChartPreview from '@/modules/goals/goals-chart-preview.vue'
import GoalsCreatePanel from './goals-create-panel.vue'
import GoalsGuards from '@/guards/goals.guards'
import multiguard from 'vue-router-multiguard'

export default {
  name: 'GoalsBranchView',
  components: {
    GoalsList,
    GoalsChartPreview,
    GoalsCreatePanel
  },
  props: {
    hideActions: {
      type: Boolean,
      default: false
    },
    hideParent: {
      type: Boolean,
      default: false
    },
    focusFirst: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showGoalsPanel: false,
      edit: false,
      showGlobal: true,
      fullscreenLoading: false
    }
  },
  computed: {
    listItems () {
      return this.$store.getters['branches/items'] // TODO: change to respective resource
    },
    profile () {
      return this.$store.getters['profile/me']
    },
    itemsGoals () {
      if (this.showGlobal && !this.hideParent) {
        return this.$store.getters['dealerGoals/items'] // TODO: change to respective resource
      } else {
        return this.$store.getters['branchGoals/items'] // TODO: change to respective resource
      }
    },
    listItemsGoals () {
      return this.$store.getters['branchGoals/items'] // TODO: change to respective resource
    },
    metGoals () {
      if (this.showGlobal && !this.hideParent) {
        return this.$store.getters['dealerGoals/globalMetGoals'] // TODO: change to respective resource
      } else {
        return this.$store.getters['branchGoals/metGoals'] // TODO: change to respective resource
      }
    },
    currentGoalItem () {
      let _currentId = null
      if (this.profile.role === 'superadmin') {
        _currentId = this.$route.params.id || (this.listItems.length ? this.listItems[0].id : null)
      } else {
        _currentId = this.$route.params.id
      }
      if (!_currentId) {
        return null
      }
      return this.listItems.find(item => {
        return parseInt(_currentId) === parseInt(item.id)
      })
    },
    currentGoals () {
      let _currentId = this.$route.params.id || (this.listItems.length ? this.listItems[0].id : null)
      if (this.showGlobal && !this.hideParent) {
        return this.itemsGoals
      } else {
        if (!_currentId) {
          return []
        }
        return this.itemsGoals.filter(goal => {
          return parseInt(_currentId) === parseInt(goal.branchId) // TODO: change to respective id
        })
      }
    },
    globalGoals () {
      return this.$store.getters['dealerGoals/items']
    }
  },
  methods: {
    onEdit (item) {
      this.clickOnItem(item)
      this.edit = true
      this.showGoalsPanel = true
      this.$forceUpdate()
    },
    onShowGoalsPanel () {
      this.edit = false
      this.showGoalsPanel = true
    },
    onCloseGoalsPanel () {
      this.showGoalsPanel = false
    },
    clickOnItem (item) {
      if (this.profile.role !== 'territorial_agco') {
        let _query = {}
        _query['branchId'] = item.id
        /* _query['year'] = moment().format('YYYY')
        if (to.query.year) {
          _query['year'] = to.query.year
        } */
        this.fullscreenLoading = true
        this.$store.dispatch('assignedGoals/get', { ..._query, limit: 1000, type: 'seller' })
          .finally(() => {
            this.fullscreenLoading = false
          })
      }
      this.$router.push({...this.$route, params: {id: item.id}})
      this.showGlobal = false
    },
    toggleGoals (show) {
      this.showGlobal = show
      if (this.profile.role !== 'territorial_agco') {
        this.fullscreenLoading = true
        if (show) {
          this.$store.dispatch('assignedGoals/get', { limit: 1000, type: 'branch' })
            .finally(() => {
              this.fullscreenLoading = false
            })
        } else {
          if (this.$route.params.id) {
            let _query = {}
            _query['branchId'] = this.$route.params.id
            this.$store.dispatch('assignedGoals/get', { ..._query, limit: 1000, type: 'seller' })
              .finally(() => {
                this.fullscreenLoading = false
              })
          }
        }
      }
    },
    reloadList () {
      this.$router.push({...this.$route, query: {...this.$route.query, reload: Date.now()}})
    }
  },
  beforeRouteUpdate: multiguard([
    GoalsGuards.onQueryGoalItems('branches'),
    GoalsGuards.onQuery('branchGoals'),
    GoalsGuards.onQueryMetGoals('branchGoals', 'branches/items'),
    GoalsGuards.onQueryGlobalGoals('dealerGoals'),
    GoalsGuards.onQueryGlobalMetGoals('dealerGoals')
    // GoalsGuards.onQueryAssignedGoals('seller', 'branchId')
  ])
}
</script>

<style lang='scss' scoped>
    .main-container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    .goals-main-list{
      height: calc(100% - 60px);
      padding: 0 15px;
      border-right: 1px solid $border-primary;
      position: relative;
      overflow: auto;
      background-color: #ffffff;
      .main-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        h1 {
          @include font-primary(21px, regular);
          color: #707070;
        }
        .el-button {
          background-color: $primary;
          border: none;
          color: #ffffff;
          box-shadow: 0 3px 6px 0 rgba(#E7120E, 0.5);
          font-size: 22px;
          padding: 7px;
        }
      }
    }
    .container-section-main {
      height: calc(100% - 60px);
      position: relative;
      overflow: auto;
      margin-right: -50px;
      background-color: $secondary;
      padding: 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/app/goals/goals-branch.view.vue